import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { showDeviationGroupListPopup } from './redux/actionCreators';
import { getDeviationTitle } from '../DeviationViews/_helpers';
export default function useDeviationGroupListPopup(deviation) {
    var _a;
    var deviationId = deviation.deviationId;
    var title = getDeviationTitle(deviation);
    var url = (_a = deviation.extended) === null || _a === void 0 ? void 0 : _a.groupListUrl;
    var dispatch = useDispatch();
    var dispatchedShowDeviationGroupListPopup = useCallback(function () {
        dispatch(showDeviationGroupListPopup({ deviationId: deviationId, url: url, title: title }));
    }, [dispatch, deviationId, url, title]);
    return dispatchedShowDeviationGroupListPopup;
}
//# sourceMappingURL=useDeviationGroupListPopup.js.map